import React, { Component } from 'react';
import successLogo from './../../../../../statics/img/esaypaisa/success.svg';
import failLogo from './../../../../../statics/img/esaypaisa/fail.svg';
import pendingLogo from './../../../../../statics/img/esaypaisa/pending.svg';
import './Easypaisa.css';

class EasypaisaStatus extends Component {
    
    componentDidMount (){
        setTimeout(()=>{
            if(this.props.status_message == "Transaction abandoned."){
                window.history.back();
            }else{
                window.location.href = this.props.redirection_url;
            }
            
        },3000)
    }

    renderSuccess = () => (
        <div>
            <img src={successLogo} />
            <h4>Payment successful</h4>
            <p>Thank you for using Easypaisa.</p>
        </div>
    )

    renderFail = () => (
        <div>
            <img src={failLogo} />
            <h4>Payment failed</h4>
            <p>{this.props.status_message != "" ? this.props.status_message : "Insufficient funds."}</p>
        </div>
    )

    renderPending = () => (
        <div>
            <img src={pendingLogo} />
            <h4>Payment pending</h4>
            <p>Thank you for using Easypaisa.</p>
            <p>Your payment is being processed.</p>
        </div>
    )

    render() {
        return (
            <div className="easypaisa_status">
                {this.props.easypaisa_status == "success" && this.renderSuccess()}
                {this.props.easypaisa_status == "fail" && this.renderFail()}
                {this.props.easypaisa_status == "pending" && this.renderPending()}
            </div>
        )
    }
}
export default EasypaisaStatus;